class LanguageService {
    static languages = {
        NL: 'nl',
        FR: 'fr',
        EN: 'en',
        ZH: 'zh',
    };

    static getLanguage = () => {
        const { lang } = document.documentElement;

        if (lang.includes('nl')) {
            return LanguageService.languages.NL;
        }

        if (lang.includes('fr')) {
            return LanguageService.languages.FR;
        }

        if (lang.includes('en')) {
            return LanguageService.languages.EN;
        }

        if (lang.includes('zh')) {
            return LanguageService.languages.ZH;
        }

        return LanguageService.languages.NL;
    };
}

export { LanguageService };
